<template>
    <div class="exam">
        <b-modal
            id="exam-modal"
            ref="exam-modal"
            :title="title"
            :title-class="['h4','text-light']"
            centered
            size="lg"
            header-bg-variant="dark"
            header-close-variant="light"
            header-text-variant="secondary"
            cancel-title = "Cancelar"
            @hidden="hiddenModal"
            no-close-on-backdrop
            ok-only
            ok-disabled 
            ok-title="Cerrar"
            ok-variant="danger"
            >
            <!-- FORM EXAM -->
            <div v-if="test.id && !isScore">
              <b-card>
                <b-form name="exam_form" id="exam_form" ref="exam_form">
                  <fieldset :disabled="formDisabled || final_score">
                    <b-tabs pills card vertical v-model="tabIndex" small>
                      <b-tab 
                        :name="'question_'+index"
                        :id="'question_'+index"
                        v-for="(item, index) in questions" 
                        v-bind:key="index" 
                        :title="'Pregunta '+(index+1)+' de '+questions.length"
                      >
                        <b-card-body>
                          <b-form-group >
                            <template #label>
                              <h5 class="text-primary font-weight-bolder">{{item.question}}</h5>
                              <!-- <span class="text-secondary font-weight-bolder font-italic">Valor:  {{item.weighing}} punto(s)</span> -->
                            </template>
                            <b-form-radio-group
                              v-model="form[index]"
                              :options="item.options"
                              stacked
                              :name="'question_'+index"
                              :id="'question_'+index"
                              @change="radioChange(index)"
                              :required="true"
                            ></b-form-radio-group>
                          </b-form-group>
                        </b-card-body>
                      </b-tab>
                    </b-tabs>
                    <b-form-invalid-feedback :state="complete">
                      Falta al menos una respuesta; revise su examen.
                    </b-form-invalid-feedback>
                    
                  </fieldset>
                </b-form>
                <b-row>
                  <b-col cols="12" class="text-danger text-right">
                    Contestadas: 
                    <span v-for="(item, index) in answereds" v-bind:key="index" > {{item}}, </span>
                  </b-col>
                  <b-col class="md-6">
                    <div class="text-left">
                      <b-button-group class="mb-2" size="sm">
                        <b-button @click="tabIndex--" variant="warning">Anterior</b-button>
                        <b-button @click="tabIndex++" variant="warning">Siguiente</b-button>
                      </b-button-group>
                    </div>
                  </b-col>
                  <b-col class="text-right md-6">
                    <b-button variant="light" disabled class="btn-sm" block>
                      <b-spinner variant="primary" small></b-spinner> Cuenta con {{this.time_elapsed}} Minuto(s) para concluir esta oportunidad
                    </b-button>
                  </b-col>
                </b-row>
                
                
                <!-- <div class="text-right">
                  <b-button-group size="sm">
                    <b-button @click="sendExam">Guardar</b-button>
                  </b-button-group>
                </div> -->
              </b-card>
            </div>
            <!-- PUNTUACION OBTENIDA -->
            <div v-else-if="isScore">
              <h1 class="text-primary">Puntuación obtenida:</h1>
              <p class="h1 mb-2 text-center font-large" v-if="isScore">
                <b-icon v-if="accreditExam" icon="check-circle-fill" variant="success"></b-icon>
                <b-icon v-else icon="x-circle-fill" variant="danger"></b-icon>
              </p>
              <div class="text-center">
                <b-button variant="light" size="lg" disabled>
                  <h1 >{{this.final_score}} Puntos</h1>
                  <h3>(Puntaje mínimo para acreditar: {{this.exam_template.score_to_pass}})</h3>
                  <h3 v-if="forced_conditions">Puntos obtenidos por respuestas correctas: {{calculateScore.score}}</h3>
                  <h3 v-if="forced_conditions" :class="calculateScore.color">{{calculateScore.msg}}</h3>
                  <!-- <h3 v-if="forced_conditions && conditionValue > 0 && (this.final_score>=this.conditionValue)">Puntos obtenidos por respuestas correctas: {{this.final_score - this.conditionValue}}</h3>
                  <h3 v-if="forced_conditions && conditionValue > 0 && (this.conditionValue>=this.final_score)">Puntos obtenidos por respuestas correctas: {{this.final_score}}</h3>
                  <h3 class="text-success" v-if="forced_conditions && (this.final_score-this.conditionValue) > 0">SI aceptó compartir sus datos.</h3>
                  <h3 class="text-danger" v-if="forced_conditions && (this.final_score-this.conditionValue) <= 0">NO aceptó compartir sus datos. Por lo que únicamente obtendrá la constancia SIN aval</h3> -->
                </b-button>
              </div>
              <h4 v-if="isScore && accreditExam">¡Felicidades! aprobó el examen.</h4>
            </div>
            <!-- INIT INSTRUCTIONS -->
            <div v-else>
              <p v-html="exam_template.description" class="text-primary" v-if="exam_template.description"></p>
              <p v-html="exam_template.instructions" v-if="exam_template.instructions"></p>
              <h4 class="text-danger" v-if="assistant_idError">{{this.assistant_idError}}</h4>
              <h4 class="text-primary" v-if="my_data.exam_approved.length >0">
                Usted ya ha aprobado el examen.
              </h4>
            </div>
            <template v-slot:modal-footer>
              <b-button-group class="float-right" size="md" v-if="!formDisabled">
                <b-button @click="hiddenModal" variant="danger" v-if="!test.id || isScore">
                  Cerrar
                </b-button>
                <b-button v-if="can_send && !isScore && my_data.exam_approved.length <= 0" @click="buttonPress" :class="[!test.id ? 'btn-success' : 'btn-primary']">
                  {{btnTitle}}
                </b-button>
                <h5 v-else-if="!can_send" class="text-danger">El tiempo para poder enviar las respuestas ha expirado.</h5>
              </b-button-group>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'ExamForm',
    props: {
      assistant: { type: Object, default: () => ({}) },
      forced_conditions: { type: Boolean, default: false }
    },
    created() {
      
    },
    data() {
        return {
          thing: {
            id: null,
            assistant_id: null,
            event_key_id: null,
            email: this.assistant.email
          },
          exam_template: {
            id: null,
            event_id: null,
            name: null,
            instructions: null,
            description: null,
            start_date: null,
            end_date: null,
            order: null,
            score_to_pass: null,
            minutes_available: null,
            maximum_attempts: null,
          },
          test: {
            id:null,
            assistant_id: null,
            key_id: null,
            minutes_elapsed: null,
            final_score: null,
          },
          questions: [],
          diploma: {
            file_path_url: null,
          },
          my_data: {
            name: null, 
            last_name: null, 
            mother_last_name: null, 
            email: null, 
            exam_approved: false, 
            remaining_attempts: null
          },
          formDisabled: false,
          errors: [],
          tabIndex: 0,
          form: {},
          complete: true,
          time_elapsed: 0,
          final_score: null,
          can_send: true,
          answereds: []
        }
    },
    methods: {
      autoIncrementTimer() {
        if (this.time_elapsed <= 0) {
          this.can_send = false
          return
        }
        this.time_elapsed --
      },
      radioChange(checked) {
        if(this.answereds.indexOf(checked+1) === -1) this.answereds.push(checked+1)
        this.complete = true
        this.tabIndex++
      },
      loadMyData() {
        let url = '/assistants/my_data'
        let method = 'post'
        this.$store.dispatch(method, {'url':url, data: {key_id: this.assistant.key_id}, headers:{}})
          .then((resp) => {
            this.my_data = resp.data
            if(this.my_data.remaining_attempts <= 0) {
              this.hiddenModal({
                'text': 'Ha completado el número de intentos de contestar su Examen.',
                'title': 'Aviso'
              })
            } /* else if(this.my_data.diploma_generated === true) {
              this.hiddenModal({
                'text': 'Su diploma /constancia ya se ha generado; el examen se ha deshabilitado.',
                'title': 'Aviso'
              })
            }  */else if(this.my_data.exam_approved.length >0) {
              this.hiddenModal({
                'text': 'Usted ya aprobó el examen.',
                'title': 'Aviso'
              })
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      loadExam() {
        let url = '/catalog/exam_templates/get_exam'
        let method = 'post'
        this.$store.dispatch(method, {'url':url, data: {event_key_id: this.eventKeyId, locale: 'es'}, headers:{}})
          .then((resp) => {
            this.exam_template = resp.data
            this.time_elapsed = this.exam_template.minutes_available
            this.questions = this.exam_template.locale_questions
            this.showModal()
          })
          .catch(err => {
            this.hiddenModal({
              'text': 'No existe Exámen disponible para éste evento.',
              'title': 'No existe registro'
            })
          })
      },
      startTest() {
        let loader = this.$loading.show()
        let url = '/catalog/tests'
        let method = 'post'
        this.errors = []
        this.$store.dispatch(method, {'url':url, data: {'assistant_id': this.assistant.id, 'exam_template_id': this.exam_template.id, 'final_score': '-1'}, headers:{}})
          .then((resp) => {
            this.test = resp.data
            this.timer = setInterval(this.autoIncrementTimer, 60000)
            loader.hide()
            this.formDisabled = false
            this.$nextTick(() => {
              
            })
          })
          .catch(err => {
            loader.hide()
            this.errors = err.errors
            this.formDisabled = false
            if(err.error) alert(err.error)
          })
      },
      showModal() {
        this.$bvModal.show('exam-modal')
      },
      hiddenModal(msg) {
        if(msg) this.$emit('closed', msg)
        else this.$emit('closed')
      },
      buttonPress() {
        this.formDisabled = true
        if(!this.test.id) {
          this.startTest()
        } else {
          this.sendExam()
        }
      },
      sendExam: function() {
        if(this.$refs.exam_form.checkValidity() === true) { 
          let loader = this.$loading.show()
          this.complete = true
          this.errors = []
          let url = '/catalog/answer_tests/responses'
          let method = 'post'

          this.$store.dispatch(method, {'url':url, data: {test_key_id:this.test.key_id, answer_options: Object.values(this.form)}, headers:{}})
            .then((resp) => {
              loader.hide()
              this.formDisabled = false
              this.final_score = resp.data.test.final_score
              this.$nextTick(() => {
                clearInterval(this.timer) 
              })
            })
            .catch(err => {
              loader.hide()
              this.formDisabled = false
              this.errors = err.errors
              //if(err.error) alert(err.error)
            })
        } else {
          this.complete = false
          this.formDisabled = false
        }
        //Object.values(this.form)
      },
    },
    beforeMount() {
      this.loadMyData()
    },
    mounted() {
      this.loadExam()
    },
    computed: {
      conditionValue () {
        if(this.forced_conditions) {
          let last = this.questions[this.questions.length - 1]
          return last?last.weighing:0
        }
      },
      calculateScore() {
        let calc = this.final_score - this.conditionValue
        if( calc === 0 ) return { score: 0, msg: 'SI acepté compartir mis datos.', color: 'text-primary' }
        if( calc < 0 ) return { score: this.final_score, msg: 'NO acepté compartir mis datos.', color: 'text-danger' }
        if( calc > 0 ) return { score: calc, msg: 'SI acepté compartir mis datos.', color: 'text-primary' }
      },
      accreditExam () {
        if(this.final_score >= this.exam_template.score_to_pass) return true
        return false
      },
      isScore() {
        if(this.final_score || this.final_score === 0) {
          return true
        }
        return false
      },
      eventKeyId() {
        return this.$store.getters.eventKeyId
      },
      title: function() {
        if(this.exam_template.name)
          return this.exam_template.name
        return "Exámen"
      },
      btnTitle: function() {
        if(this.test.id) {
          return 'Finalizar'
        } else return 'Iniciar'
      },
      assistant_idError: function () {
        if(this.errors && this.errors.assistant_id) return this.errors.assistant_id[0]
        return null
      },
    },
})
</script>

<style lang="scss" scoped>
  @import '../../styles/app';
</style>